export default __webpack_public_path__ + "static/linkBg8_shadow-50c2640a2166f439b4819db428186e73.png";